export const MIN_ELEMENT_SIZE = 20;
export const HANDLE_SIZE = 8;       // visual px on screen, zoom-compensated
export const CANVAS_PADDING = 48;   // px of gray space around the canvas
export const SNAP_THRESHOLD = 5;

export type HandleDirection =
  | 'nw' | 'n' | 'ne'
  | 'w'  |       'e'
  | 'sw' | 's' | 'se';

export const HANDLES: {
  dir: HandleDirection;
  cursor: string;
  getPos: (w: number, h: number, half: number) => { x: number; y: number };
}[] = [
  { dir: 'nw', cursor: 'nwse-resize', getPos: (_w, _h, half) => ({ x: -half, y: -half }) },
  { dir: 'n',  cursor: 'ns-resize',   getPos: (w, _h, half)  => ({ x: w / 2 - half, y: -half }) },
  { dir: 'ne', cursor: 'nesw-resize', getPos: (w, _h, half)  => ({ x: w - half, y: -half }) },
  { dir: 'w',  cursor: 'ew-resize',   getPos: (_w, h, half)  => ({ x: -half, y: h / 2 - half }) },
  { dir: 'e',  cursor: 'ew-resize',   getPos: (w, h, half)   => ({ x: w - half, y: h / 2 - half }) },
  { dir: 'sw', cursor: 'nesw-resize', getPos: (_w, h, half)  => ({ x: -half, y: h - half }) },
  { dir: 's',  cursor: 'ns-resize',   getPos: (w, h, half)   => ({ x: w / 2 - half, y: h - half }) },
  { dir: 'se', cursor: 'nwse-resize', getPos: (w, h, half)   => ({ x: w - half, y: h - half }) },
];

export interface Interaction {
  mode: 'drag' | 'resize' | 'rotate';
  elementIndex: number;
  startMouseX: number;
  startMouseY: number;
  startElX: number;
  startElY: number;
  startElW: number;
  startElH: number;
  handleDir?: HandleDirection;
  startAngle?: number;
  startRotation?: number;
}

export interface SnapGuide {
  orientation: 'horizontal' | 'vertical';
  position: number;
}

// ── Font Options ──────────────────────────────────────────────

export const FONT_OPTIONS = [
  { value: 'Inter, sans-serif', label: 'Inter' },
  { value: 'Arial, sans-serif', label: 'Arial' },
  { value: 'Helvetica, Arial, sans-serif', label: 'Helvetica' },
  { value: 'Georgia, serif', label: 'Georgia' },
  { value: 'Times New Roman, serif', label: 'Times New Roman' },
  { value: 'Verdana, sans-serif', label: 'Verdana' },
  { value: 'Trebuchet MS, sans-serif', label: 'Trebuchet MS' },
  { value: 'Roboto, sans-serif', label: 'Roboto' },
  { value: 'Open Sans, sans-serif', label: 'Open Sans' },
  { value: 'Poppins, sans-serif', label: 'Poppins' },
  { value: 'Montserrat, sans-serif', label: 'Montserrat' },
  { value: 'Lato, sans-serif', label: 'Lato' },
  { value: 'monospace', label: 'Monospace' },
  { value: 'Cairo, sans-serif', label: 'Cairo (Arabic)' },
  { value: 'Tajawal, sans-serif', label: 'Tajawal (Arabic)' },
  { value: 'Noto Sans Arabic, sans-serif', label: 'Noto Sans Arabic' },
  { value: 'Amiri, serif', label: 'Amiri (Arabic Serif)' },
  { value: 'IBM Plex Sans Arabic, sans-serif', label: 'IBM Plex Sans Arabic' },
];

export const WEIGHT_OPTIONS = [
  { value: 'normal', label: 'Normal' },
  { value: 'bold', label: 'Bold' },
  { value: '300', label: 'Light' },
  { value: '500', label: 'Medium' },
  { value: '600', label: 'Semibold' },
  { value: '800', label: 'Extra Bold' },
];

export const ZOOM_PRESETS = [0.25, 0.5, 0.75, 1, 1.5, 2];
